import { render, staticRenderFns } from "./CheckboxesField.vue?vue&type=template&id=2a97005c&scoped=true&"
import script from "./CheckboxesField.vue?vue&type=script&lang=js&"
export * from "./CheckboxesField.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesField.vue?vue&type=style&index=0&id=2a97005c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97005c",
  null
  
)

export default component.exports